import styled from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"
import { overrideHorizontalRuleBorder } from "QuorumGrassroots/styled-components/helperFunctions"

export const StyledHorizontalRule = styleWithOrgDesign(styled.hr`
    border-top: 1px solid ${(props) => props.organizationDesign.secondary_color};
    width: 100%;
    ${(props) => overrideHorizontalRuleBorder(props)}
`)
